// extracted by mini-css-extract-plugin
export default {"container":"style_container__fZ9lA","clientsImgCont":"style_clientsImgCont__JvYr0"};